// extracted by css-extract-rspack-plugin
export default {"dropdown":"WuHtz","dropdownContent":"KE99e"};